import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Link from "next/link";
import NewsletterSignup from "./NewsletterSignup";
import styles from "../styles/Footer.module.css";
import { Icon } from "react-icons-kit";
import { facebook } from "react-icons-kit/icomoon/facebook";
import { twitter } from "react-icons-kit/icomoon/twitter";
import { instagram } from "react-icons-kit/icomoon/instagram";
import { youtube } from "react-icons-kit/icomoon/youtube";

export default function Footer() {
  return (
    <>
      <footer className={styles.footer}>
        <div className="container-fluid px-lg-5">
          <div className="row">
            <div className="col-lg-2 col-md-4 mb-4">
              <h4 className="text-white mb-3 text-uppercase">
                <Link href="/about-us">
                  <a className="text-white">ABOUT US</a>
                </Link>
              </h4>
              <div className="mb-2">
                Sell used or buy renewed gadgets across India
              </div>
              <div className="mb-2">
                <div className="d-inline-flex gap-1">
                  <div>
                    <svg
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <rect
                        y="0.581055"
                        width="9.45"
                        height="13"
                        fill="url(#pattern0_184_1738)"
                      />
                      <rect
                        x="0.5"
                        y="1.08105"
                        width="8.45"
                        height="12"
                        stroke="white"
                        strokeOpacity="0.05"
                      />
                      <defs>
                        <pattern
                          id="pattern0_184_1738"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            xlinkHref="#image0_184_1738"
                            transform="scale(0.0526316 0.0357143)"
                          />
                        </pattern>
                        <image
                          id="image0_184_1738"
                          width="19"
                          height="28"
                          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAYAAACDBoQZAAAAAXNSR0IArs4c6QAABPpJREFUSEudlQtQVGUUx//fvbuL4aNA4+HowNBqq6LIq1EHiIdSAwJiD5MAcyBAjXESQWe0XKWaEBzHQSPARyIoymguM+kCAwpiqCFB8pAQhUpHIVBLCJe99zbn7sIkD6e6Mzv73fvt+d3/Od//nGV4zpV5SOfh4OToBQuVVdfDvl9/6+ys0K5/6/Z4IWzkRvLuI3bBy4M/cdO87DuBwVIAHI0ABgEogA5DP3qbf7yu8/Hy2DUy9hnYkdKaD4L9Fm2cxGPhC7QjAYIggVcwQAQGBQlKJYMB6OjoenpLpzufnBIXXj8EHYYdLb8a6+PzWtIMBTQK864gARIDOAAcrQWAcYMwQolHItDzB6oLi3Tx2oQVzRQiw7LyzviHrgpLn6ri3HhRBBMEQKmUU3toEgglgBcBqChAlACO4QmAli4UH8zKWZ2jje+XYdfauo+5qadFUhRPGQmAgUP7zc6eS8VV9Xm/9PQ2uM209fVfvGDNq/YvuTAODjITQDeA8svtye97qTPY3qIy37eDlu6bYYkFsgQB+EtAW0lldUb4G945I4tcUdu+x8XFaZP1UC0ANPVK+lWZu8LYicobm4N8nNOnEIgBgxJQU9eZ8bqHY/JYFojTZltu/CiueO5UBEAUAaMRvytUSD5V68cutvRku2qs4yabI7sAFBRcWJoU6V8+np90126lhni+sp0ZTbXrl4ADVbdi2LWOvlyNg2WspbnQnQJw/HiZ76fRgZXjwQ6W1sa+5++eO5GyESUM8AxfXWiMYRdbu7NdZ0+LmwKAzPkAwMnCsqVJqwPHVXa67l7qclf77SpSxhgMPJB2vjmGFVU3bQ5YPDfdigOMAvCEB2qu3swIWjRn3JptSIwrnmONALILHdhjCfissNqPfXm4ZElURGCmjQXcOKMBHK+CwYi2c6UXMsKX+486zZqWjj0LNA6bLEyi8BTA7a4B/c6stDDZZzWNd3M9502PlQwDUCgmyJYfMKC9oePepcr6lrz7d3sb1OSzJa5rZtpPdrFgcBCNAlQKXvaZvuL6uugAj69lWMHZ0qCVwcvSeMCZlyRwCiafOscDfdQMvNn5ZqNS3c0Z4kaPsTRn/+Hw4Q6gjYbWe0dnz7KPVlIXUDOafWdaDN0w+ZBIAf3kTxH47lLTlghf593DvUmLQ6cqQkOC/D6fOhHOVFS6SBm1DF1DanhTzeW+ffDIePGb3PzV2pS195+B0U3dnYHTLo4WK+mtIjU8Y5DoY05Pnh6CCMZz6AdQebl5V5DXvB2jRhA9yD5bGxEZ4l5gKdNo3pgTMo0zk1pzynf6cSXvWFGMNuFdefyMUvaOVqtKjf+4aJbdlFCOxgwBqYDyMdEbTC8xcDxKatu/CPVUbxsCjYLRgyP62oTAZe5Z0yl2UJRntQlmAtLA7OkbrMvX6TckRYZeeS6M1G1dt0O30AZvylrkgxTN3xyNbPzQ1L7fy1md+E/QmMro4cnKls1h3pp0CyZCBGdKUBIhMg73+1FXeEaXmBS14vt/BUvefcBufWz0CVurSb40pskO8p8LA+rvdOd5ONmsGQkaV5msruqnFD/v+WnWBBMMAK/C4wFjY1GxfsuHq0LO/SfY1r2HnaJi1h5VT4YXnQE5/+fWzvz5GseosUDPVUab31Y1pyzynhMjt+ZT9JacKd4WFRGm/18wCkrQ5tnYqu2ddkYue8YGYwH/Bowr6FXWgkLIAAAAAElFTkSuQmCC"
                        />
                      </defs>
                    </svg>
                  </div>
                  <span>
                    Budli Internet Pvt. Ltd.No. 11, 80 Feet Road, 1st
                    Floor,Koramangala 1st Block,Bangalore 560034. India.
                  </span>
                </div>
              </div>
              <div className="mb-2">
                <a href={`tel:+91${process.env.NEXT_PUBLIC_CONTACT_NO}`}>
                  <div className="d-inline-flex gap-1">
                    <div>
                      <svg
                        width="10"
                        height="14"
                        viewBox="0 0 10 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          y="0.36084"
                          width="9.17"
                          height="13"
                          fill="url(#pattern0_184_1742)"
                        />
                        <rect
                          x="0.5"
                          y="0.86084"
                          width="8.17"
                          height="12"
                          stroke="white"
                          strokeOpacity="0.05"
                        />
                        <defs>
                          <pattern
                            id="pattern0_184_1742"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlinkHref="#image0_184_1742"
                              transform="scale(0.0666667 0.0434783)"
                            />
                          </pattern>
                          <image
                            id="image0_184_1742"
                            width="15"
                            height="23"
                            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAXCAYAAADUUxW8AAAAAXNSR0IArs4c6QAAAvNJREFUOE/FVF1IU2EYfr7tbHMOLdMULQl/jrqJFY4uEotERMO6MktOaWIp/ZimJHVRF91JVmCMyiAy6WAXYUoiToQWWaYdKsNhTSyouTaVlMrp9PzEtyZhF+ad3837fnzn+d7n/c7zPgSBdf529zZ9cEg4MA+IInRM0NIRwATBJwKK4l24fDSrb+mA1Dc9SCsqOnzPEIp4EQhTAyAAVACUQE6jBEAGpskcpp8/tV0pzM9qIrb3n+6kp8WVhwSukwGIAOYCF+gAaP9y8Gcfp319BTfqs8mgw8Ob2EgumFZSAIUArol5jLo8EBclRIeFwBi/EQylQpcsYsyrxvGWHpYM2Cd5oymCWwxQpNH/TYA2zWkrDI0KECrLcPoUlLf2smRwZJJnUyK4AfvEO2Fo+LoGEtS0Qaj9fUpqCbI/1yI+cl1mwS5TxZQEVDb3skRwTPHxbDjXbn1jKcszn/mnvWXbSzc7zZUlOcIso8XZu1Za2c0npERxT6xvLaV56SuCLzQ+Np8uyRV8ej1qKViwu/hEUzTXvkpwdUmu4NXoUXN/GXjIUpq3/b+Va4pzBa9Wj+o1BtMHS47iOnpW92DLaa8d2OHh49hIrmMVIqH/ubpkr18ktVTbVGGxCeFcW9cry8n9O1dWWKPVXHFkj+DVaVH30MaS/hE3vyUpiuu2CZay7B0rg692mqsq8oXvKgTAw+O8MTWGG3a5FyY8U/26RR000IKOgyyJUEGGitDBCMJ6Q9Amc3JEonMBONViY8lL+zhvNMVwPyHCAAbUfH4owNgMMDkpYncS4zcDTWBOqTk4vUBti5Ulzxxf+a3sZo6BAi0UEKgwLgNVzS8wOvYZt04UIiNW98dNpEVAUuHbrDTU0NZ9gHQMu65lpkbXhvoneA4EGkyAwcVHr/HF6UZ98T6kbSBQU2Okzka0+OCcsRljw7JIcUOL4dhBrjU9Wp0RopFVkOYAdTBmQcR5CT6NDEMo5ayIUAgjO37B1dnVW3fuUI71N7Uof/5pFJcCAAAAAElFTkSuQmCC"
                          />
                        </defs>
                      </svg>
                    </div>
                    <span>+91 {process.env.NEXT_PUBLIC_CONTACT_NO}</span>
                  </div>
                </a>
              </div>
              <div className="mb-2">
                <a href="mailto:hello@budli.in">
                  <div className="d-inline-flex gap-1">
                    <div>
                      <svg
                        width="12"
                        height="14"
                        viewBox="0 0 16 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <rect
                          y="0.951172"
                          width="15.53"
                          height="13"
                          fill="url(#pattern0_184_1745)"
                        />
                        <rect
                          x="0.5"
                          y="1.45117"
                          width="14.53"
                          height="12"
                          stroke="white"
                          strokeOpacity="0.05"
                        />
                        <defs>
                          <pattern
                            id="pattern0_184_1745"
                            patternContentUnits="objectBoundingBox"
                            width="1"
                            height="1"
                          >
                            <use
                              xlinkHref="#image0_184_1745"
                              transform="scale(0.03125 0.0384615)"
                            />
                          </pattern>
                          <image
                            id="image0_184_1745"
                            width="32"
                            height="26"
                            xlinkHref="data:image/png;base64,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"
                          />
                        </defs>
                      </svg>
                    </div>
                    <span>hello@budli.in</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 mb-4">
              <h4 className="text-white mb-3">
                <div className="text-uppercase">ARE WE FRIENDS YET?</div>
                Sign up for great deals!
              </h4>
              <NewsletterSignup />
              <h4 className="text-white mb-3">Follow us on</h4>
              <ul className={styles.social_icon}>
                <li className={styles.facebook}>
                  <a href="https://www.facebook.com/Budli.in" target="_blank">
                    <Icon icon={facebook} size={20} />
                  </a>
                </li>
                <li className={styles.instagram}>
                  <a href="https://instagram.com/budli.in" target="_blank">
                    <Icon icon={instagram} size={20} />
                  </a>
                </li>
                <li className={styles.youtube}>
                  <a href="https://www.youtube.com/c/BudliIn" target="_blank">
                    <Icon icon={youtube} size={20} />
                  </a>
                </li>
                <li className={styles.twitter}>
                  <a href="https://twitter.com/Budli_in" target="_blank">
                    <svg
                      width="18"
                      fill="#fff"
                      enableBackground="new 0 0 1226.37 1226.37"
                      viewBox="0 0 1226.37 1226.37"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m727.348 519.284 446.727-519.284h-105.86l-387.893 450.887-309.809-450.887h-357.328l468.492 681.821-468.492 544.549h105.866l409.625-476.152 327.181 476.152h357.328l-485.863-707.086zm-144.998 168.544-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721h-162.604l-323.311-462.446z" />
                    </svg>
                  </a>
                </li>
                <li className={styles.twitter}>
                  <a
                    href="https://www.linkedin.com/company/budliinternet/"
                    target="_blank"
                  >
                    <svg
                      fill="#fff"
                      enableBackground="new 0 0 24 24"
                      height="20"
                      viewBox="0 0 24 24"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" />
                      <path d="m.396 7.977h4.976v16.023h-4.976z" />
                      <path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" />
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 mb-4">
              <h4 className="text-white mb-3 text-uppercase">
                CUSTOMER SERVICE
              </h4>
              <ul>
                <li>
                  <Link href="/privacy-policy">
                    <a>Privacy Policy</a>
                  </Link>
                </li>
                <li>
                  <Link href="https://buy.budli.in/pages/warranty">
                    <a>Warranty</a>
                  </Link>
                </li>
                <li>
                  <Link href="/terms-conditions">
                    <a>Terms and Conditions</a>
                  </Link>
                </li>
                <li>
                  <Link href="https://buy.budli.in/pages/certification">
                    <a>Certification</a>
                  </Link>
                </li>
                <li>
                  <Link href="/faq">
                    <a>FAQ</a>
                  </Link>
                </li>
                <li>
                  <Link href="https://buy.budli.in/pages/shipping-and-returns">
                    <a>Shipping and Returns</a>
                  </Link>
                </li>
                <li>
                  <Link href="/contact-us">
                    <a>Contact us</a>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 mb-4">
              <h4 className="text-white mb-3 text-uppercase">COMPANY</h4>
              <ul>
                <li>
                  <Link href="/about-us">
                    <a>About Us</a>
                  </Link>
                </li>
                <li>
                  <a href="https://budli.in/blog/" target="_blank" rel="noopener noreferrer">
                    Blog
                  </a>
                  
                </li>
                <li>
                  <Link href="/user-reviews">
                    <a>User Reviews</a>
                  </Link>
                </li>
                <li>
                  <Link href="/career">
                    <a>Career</a>
                  </Link>
                </li>
                <li>
                  <Link href="/budli-for-business">
                    <a>Budli for Business</a>
                  </Link>
                </li>
                <li>
                  <Link href="/contact-us">
                    <a>Budli for Resellers</a>
                  </Link>
                </li>
                <li>
                  <Link href="/budli-charity">
                    <a>Charity</a>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 mb-4">
              <h4 className="text-white mb-3 text-uppercase">
                <Link href="/sell">
                  <a className="text-white">SELL USED GADGETS</a>
                </Link>
              </h4>
              <ul>
                <li>
                  <Link href="/sell-used-mobile-phones">
                    <a>Sell Used Mobiles</a>
                  </Link>
                </li>
                <li>
                  <Link href="/sell-used-tablets">
                    <a>Sell Used Tablets</a>
                  </Link>
                </li>
                <li>
                  <Link href="/sell-used-laptops">
                    <a>Sell Used Laptops</a>
                  </Link>
                </li>
                <li>
                  <Link href="/sell-used-othergadgets">
                    <a>Sell Other Gadgets</a>
                  </Link>
                </li>
                <li>
                  <Link href="/how-it-works">
                    <a>How it Works</a>
                  </Link>
                </li>
                <li>
                  <Link href="https://budli.in/devicetodream">
                    <a>Donate</a>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 mb-4">
              <h4 className="text-white mb-3 text-uppercase">
                <Link href="https://buy.budli.in/">
                  <a className="text-white">Buy Refurbished Gadgets</a>
                </Link>
              </h4>
              <ul>
                <li>
                  <Link href="https://buy.budli.in/collections/refurbished-mobiles">
                    <a>Refurbished Mobiles</a>
                  </Link>
                </li>
                <li>
                  <Link href="https://buy.budli.in/collections/buy-refurbished-laptop/Refurbished-Laptops">
                    <a>Refurbished Laptops</a>
                  </Link>
                </li>
                <li>
                  <Link href="https://buy.budli.in/collections/buy-refurbished-tablets">
                    <a>Refurbished Tablets</a>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="pb-3 borderbottom mb-3">
            © {new Date().getFullYear()} Budli Internet Private Limited - All
            Rights Reserved.
          </div>
          <h4 className="text-white mb-3">
            <Link href="/sell">
              <a className="text-white">Most searched on Budli</a>
            </Link>
          </h4>
          <div className="mb-2">
            <strong>
              <Link href="/sell-used-mobile-phones">
                <a className="text-white">Sell Mobile Online: </a>
              </Link>
            </strong>
            <Link href="https://budli.in/sell-used-mobile-phones/apple-iphone">
              <a>Sell iPhone</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/samsung">
              <a>Sell Samsung Mobile</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/oneplus">
              <a>Sell Oneplus Mobile</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/motorola">
              <a>Sell Moto Mobile</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/xiaomi">
              <a>Sell Redmi mobile</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/realme">
              <a>Sell Realme Mobile</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/google">
              <a>Sell Pixel</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/oppo">
              <a>Sell Oppo</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-mobile-phones/vivo">
              <a>Sell Vivo</a>
            </Link>
          </div>
          <div className="mb-2">
            <strong>
              <Link href="/sell-used-laptops">
                <a className="text-white">Sell Old Laptop: </a>
              </Link>
            </strong>
            <Link href="https://budli.in/sell-used-laptops/apple-macbook">
              <a>Sell Macbook</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-laptops/other-laptop">
              <a>Sell Windows Laptop</a>
            </Link>
          </div>
          <div className="mb-2">
            <strong>
              <Link href="/sell-used-tablets">
                <a className="text-white">Sell Tablet: </a>
              </Link>
            </strong>
            <Link href="https://budli.in/sell-used-tablets/apple-ipad">
              <a>Sell iPad</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-tablets/samsung">
              <a>Sell Samsung Tab</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-tablets/lenovo">
              <a>Sell Lenovo Tab</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://budli.in/sell-used-tablets/xiaomi">
              <a>Sell Xiaomi Tab</a>
            </Link>
          </div>
          <div className="mb-2">
            <Link href="https://buy.budli.in/collections/refurbished-mobiles">
              <a>Buy Second Hand Mobile</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://buy.budli.in/collections/buy-refurbished-laptop">
              <a>Buy Used Laptop</a>
            </Link>{" "}
            |&nbsp;
            <Link href="https://buy.budli.in/collections/tablets">
              <a>Refurbished iPad</a>
            </Link>
          </div>
        </div>
        {/*    
        <Container fluid>
          <Row>
            <ul className={`${styles.footer_menu} col-lg-3 col-md-3`}>
              <li>
                <Link href="/about-us">About Us</Link>
              </li>
              <li>
                <Link href="/why-budli">Why Budli</Link>
              </li>
              <li>
                <Link href="/how-it-works">How It Works</Link>
              </li>
              <li>
                <Link href="/faq">FAQs</Link>
              </li>
            </ul>
            <ul className={`${styles.footer_menu} col-lg-3 col-md-3`}>
              <li>
                <Link href="/budli-for-business">Budli For Business</Link>
              </li>
              <li>
                <Link href="/budli-charity">Charity</Link>
              </li>
              <li>
                <Link href="/user-reviews">User Reviews</Link>
              </li>
              <li>
                <a href="https://budli.in/blog/">Blog</a>
              </li>
            </ul>
            <ul className={`${styles.footer_menu} col-lg-3 col-md-3`}>
              <li>
                <Link href="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link href="/career">Careers</Link>
              </li>
              <li>
                <Link href="/privacy-policy">Privacy</Link>
              </li>
              <li>
                <Link href="/terms-conditions">Terms &amp; Conditions</Link>
              </li>
            </ul>
            <div className={`${styles.footer_contact} col-lg-3 col-md-3`}>
              
              <a href="mailto:hello@budli.in">hello@budli.in</a>
              <a href={`tel:+91${process.env.NEXT_PUBLIC_CONTACT_NO}`}>
                +91 {process.env.NEXT_PUBLIC_CONTACT_NO}
                <br />
                (Mon - Sat 10 AM - 7 PM)
              </a>
              <div>&nbsp;</div>
              
            </div>
          </Row>
        </Container>
        <Container fluid className={styles.copyright}>
          <Row className="justify-content-center">
            <Col md={6}>
              All Rights Reserved © {new Date().getFullYear()} - Budli Internet
              Private Limited
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
            </Col>
          </Row>
        </Container>
        <Container fluid className={styles.footer_links} id={styles.link}>
          <p>
            <b>Most Sold products on budli</b>
          </p>
          <strong>
            <Link href="/sell-used-mobile-phones">Sell Old Mobiles</Link> :
            &nbsp;
          </strong>
          <Link href="/sell-used-mobile-phones/nokia">Sell Nokia Mobiles</Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/samsung">
            Sell Samsung Mobiles
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/apple-iphone">
            Sell Apple iPhones
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/sony">
            Sell Sony Mobiles
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/micromax">
            Sell Micromax Mobiles
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/motorola">
            Sell Motorola Mobiles
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/asus">
            Sell Asus Mobiles
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/lenovo">
            Sell Lenovo Mobiles
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-mobile-phones/xiaomi">
            Sell Xiaomi Mobiles
          </Link>
          <br />
          <strong>
            <Link href="/sell-used-tablets">Sell Old Tablets</Link> :
            &nbsp;&nbsp;
          </strong>
          <Link href="/sell-used-tablets/samsung">Sell Samsung Tablets</Link>{" "}
          |&nbsp;
          <Link href="/sell-used-tablets/apple-ipad">
            Sell Apple iPads
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-tablets/micromax">
            Sell Micromax Tablets
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-tablets/asus">Sell Asus Tablets</Link> |&nbsp;
          <Link href="/sell-used-tablets/dell">Sell Dell Tablets</Link> |&nbsp;
          <Link href="/sell-used-tablets/lenovo">Sell Lenovo Tablets</Link>
          <br />
          <strong>
            <Link href="/sell-used-laptops">Sell Old Laptops</Link> : &nbsp;
          </strong>
          <Link href="/sell-used-laptops/other-laptop">Sell Dell Laptops</Link>{" "}
          |&nbsp;
          <Link href="/sell-used-laptops/other-laptop">
            Sell Lenovo Laptops
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-laptops/other-laptop">
            Sell Samsung Laptops
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-laptops/apple-macbook">
            Sell Apple Macbooks
          </Link>{" "}
          |&nbsp;
          <Link href="/sell-used-laptops/other-laptop">Sell Asus Laptops</Link>
          <br />
          <strong>
            <Link href="/sell-used-othergadgets">Sell Other Gadgets</Link> :
            &nbsp;
          </strong>
          <Link href="/sell-used-othergadgets/apple">
            Sell Apple Accessories
          </Link>
          |&nbsp;
          <Link href="/sell-used-othergadgets/amazon">
            Sell Amazon Accessories
          </Link>
          |&nbsp;
          <Link href="/sell-used-othergadgets/google">
            Sell Google Accessories
          </Link>
          <br />
          <strong>
            <Link href="https://buy.budli.in/collections/refurbished-mobiles">
              Buy Refurbished Mobiles
            </Link>{" "}
          </strong>{" "}
          |{" "}
          <strong>
            <Link href="https://buy.budli.in/collections/buy-refurbished-tablets">
              Buy Refurbished Tablets
            </Link>{" "}
          </strong>{" "}
          |{" "}
          <strong>
            <Link href="https://buy.budli.in/collections/buy-refurbished-laptop/Refurbished-Laptops">
              Buy Refurbished Laptops
            </Link>{" "}
          </strong>{" "}
          |{" "}
          <strong>
            <Link href="https://buy.budli.in/collections/other-gadgets">
              Buy Other Gadgets
            </Link>{" "}
          </strong>
          |{" "}
          <strong>
            <Link href="https://buy.budli.in/collections/smart-home-gadgets">
              Buy Smart Home Gadgets
            </Link>{" "}
          </strong>
        </Container>*/}
      </footer>
    </>
  );
}
